import { useEffect, useState } from 'react';

import { useLocation, Link as RouterLink } from 'react-router-dom';

import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Flex,
  Link,
  useColorModeValue,
} from '@chakra-ui/react';

import TopNavigationTools from 'layouts/admin/navbar/TopNavigationTools';

import routes from 'routes';

import { getActiveRoute, getActiveBreadcrumbs, BreadcrumbData } from './utils';

const TopNavigation = ({ theme, setTheme }: { [x: string]: any }) => {
  const [pageName, setPageName] = useState(getActiveRoute(routes));
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbData[]>(
    getActiveBreadcrumbs(routes),
  );
  const location = useLocation();

  const mainText = useColorModeValue('navy.700', 'white');
  const secondaryText = useColorModeValue('gray.500', 'gray.400');

  useEffect(() => {
    setPageName(getActiveRoute(routes));
    setBreadcrumbs(getActiveBreadcrumbs(routes));
  }, [location.pathname]);

  return (
    <Box
      position="fixed"
      bg={useColorModeValue('rgba(244, 247, 254, 0.2)', 'rgba(11,20,55,0.5)')}
      backdropFilter="blur(20px)"
      lineHeight="25.6px"
      p="12px"
      top="18px"
      w={{
        base: 'calc(100% - 40px)',
        hxl: 'calc(100% - 340px)',
      }}
      right="20px"
      borderTopRadius={10}
    >
      <Flex
        flexDirection={{ sm: 'column', md: 'row' }}
        alignItems={{ hxl: 'center' }}
      >
        <Box mb={{ sm: '8px', md: '0px' }}>
          <Breadcrumb>
            <BreadcrumbItem color={secondaryText} fontSize="sm" mb="5px">
              <Link as={RouterLink} to="/admin/home">
                Home
              </Link>
            </BreadcrumbItem>
            {breadcrumbs.map((crumb, index) => (
              <BreadcrumbItem key={index} color={secondaryText} fontSize="sm">
                {crumb.path ? (
                  <Link as={RouterLink} to={crumb.path}>
                    {crumb.name}
                  </Link>
                ) : (
                  <Box>{crumb.name}</Box>
                )}
              </BreadcrumbItem>
            ))}
          </Breadcrumb>
          {pageName !== 'Home' && (
            <Link color={mainText} href="#" fontWeight="bold" fontSize="34px">
              {pageName}
            </Link>
          )}
        </Box>

        <Box ms="auto">
          <TopNavigationTools theme={theme} setTheme={setTheme} />
        </Box>
      </Flex>
    </Box>
  );
};

export default TopNavigation;
